// extracted by css-extract-rspack-plugin
export default {"helpLink":"RemoveUserModal_helpLink__rWlks"};